import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import { DatePicker } from 'antd';

import { Container } from './styles';

export default function Header({ changeDate, getMonthDateRange }) {
  return (
    <Container>
      <img src="https://app.qesh.ai/static/media/qesh-logo-color-vtc.85e4545b.svg" alt="Logo" height="80" />
      <div>
        <DatePicker.RangePicker
          format="DD/MM/YYYY"
          onChange={changeDate}
          defaultValue={[
            moment(getMonthDateRange().start, 'DD-MM-YYYY'),
            moment(getMonthDateRange().end, 'DD-MM-YYYY'),
          ]}
        />
      </div>
    </Container>
  );
}

Header.propTypes = {
  changeDate: PropTypes.func.isRequired,
  getMonthDateRange: PropTypes.func.isRequired,
};
